import {
  BuildingConstants,
  BuildingReducer,
  BuildingActionTypes,
  BuildingsListBuilding,
  BuildingStatusBuilding,
  SelectedBuilding,
  CategoryType,
  SubCategoryType,
  NavigationParamsType,
} from './types';

export const initialState: BuildingReducer = {
  navigationParams: {
    selectedCategory: {
      api_location: '',
      id: '',
      image: '',
      name: '',
      sub_categories: [] as SubCategoryType[],
      url: '',
    } as CategoryType,
    selectedSubCategory: {
      api_location: '',
      data_api_location: '',
      id: '',
      name: '',
      url: '',
    },
  } as NavigationParamsType,
  selectedBuilding: {
    identifier: '',
    name: '',
    api_location: '',
    savings_start_datetime: '',
    installation_start_date: '',
    navigation: [],
  } as SelectedBuilding,
  buildingsList: [] as BuildingsListBuilding[],
  buildingStatusList: [] as BuildingStatusBuilding[],
  error: undefined,
};

export function buildingReducer(state: BuildingReducer = initialState, action: BuildingActionTypes) {
  switch (action.type) {
    case BuildingConstants.SetBuildingsList:
      return {
        ...state,
        buildingsList: action.payload,
      };
    case BuildingConstants.SetBuildingStatusList:
      return {
        ...state,
        buildingStatusList: action.payload,
      };
    case BuildingConstants.SetSelectedBuilding:
      return {
        ...state,
        selectedBuilding: action.payload,
      };
    case BuildingConstants.SetNavigationParams:
      return {
        ...state,
        navigationParams: action.payload,
      };
    case BuildingConstants.SetSelectedBuildingError:
      return {
        ...state,
        error: action.payload,
      };
    case BuildingConstants.ClearSelectedBuildingError:
      return {
        ...state,
        error: undefined,
      };
    default:
      return state;
  }
}
